define('edap-optimizely-integration',['edap','domhelpers'], function(edap, domHelpers) {
    'use strict';

    var moduleName = 'optimizely',
        myEdap = new edap.Scope(moduleName),
        optimizelyStr = 'optimizely';

    myEdap.on('optimizely.load', function(data) {
        if (typeof domHelpers.getWindow().optimizely === 'object') {
            return;
        }

        if (typeof data[optimizelyStr] === 'string') {
            domHelpers.loadScript('//cdn.optimizely.com/js/' + data[optimizelyStr] + '.js');
        }
    });

    return edap;
});

